module.exports = __webpack_public_path__ + "static/media/Shannon.7d4f4a51.jpg";